
import Vue from 'vue';
import LogoAgrotools from '@/components/Logos/Agrotools/index.vue';
import { isBayer } from '@/utils';
import { Wrapper } from './styles';

export default Vue.extend({
  name: 'Footer',
  components: {
    LogoAgrotools,
    Wrapper,
  },
  data() {
    return {
      isBayer: false,
    };
  },
  mounted() {
    this.isBayer = isBayer();
  },
});
